// import mixin from "../../../../mixins/mixin";


export default {
    data() {
        return {
            loading: false
        }
    },
    components: {

    },
    async mounted() {

    },
    watch: {

    },
    methods: {

    }
};



// WEBPACK FOOTER //
// ./src/app/pages/payment-rules/index/index.js